import { styled } from "@mui/material";

export const PasswordTooltip = styled("div")`
	box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
`;

export default PasswordTooltip;
